export default __webpack_public_path__ + "static/media/mars11.cc9967fc.gif";